<template>
  <div class="wishlist-card">
    <div class="wishlist-card__delete"
         @click="$emit('deleteClick', wishlist.id)">
      <b-button variant="danger"
                aria-label="Delete wishlist"
                class="btn btn-sm">
        <span class="visually-hidden">
          Delete wishlist
        </span>
        <font-awesome-icon :icon="['far', 'trash-alt']">
        </font-awesome-icon>
      </b-button>
    </div>

    <div class="wishlist-card__title">
      {{ wishlist.title }}
    </div>
    <div class="wishlist-card__date">
      {{ formatDate(wishlist.date) }}
    </div>

    <div class="wishlist-card__data">
      <div class="row no-padding">
        <div class="col-md-4 no-padding">
          <div class="wishlist-card__product-count">
            Products: {{ wishlist.sopLines.length }}
          </div>
        </div>
        <div class="col-md-4 no-padding">
          <div class="wishlist-card__order-status">
            Ordered:
            <template v-if="wishlist.statusId === 'PRO'">
              Yes
            </template>
            <template v-else>
              No
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="wishlist-card__actions">
      <!-- Add all wishlist products to basket CTA -->
      <move-to-basket
        :wish-list-id="wishlist.id"
        :wish-list-products="wishlist.sopLines"
        class="btn-padding"
        @success="val => $emit('addToBasketSuccess', val)"
        @loading="val => $emit('loading', val)">
      </move-to-basket>
      <button
        class="btn btn-sm btn-accent-1 btn-padding"
        aria-label="View wishlist"
        @click="$emit('viewClick', wishlist.id)">
        View
      </button>
      <button
        class="btn btn-sm btn-accent-1 btn-padding"
        aria-label="Email wishlist"
        @click="$emit('emailClick', wishlist.id)">
        <font-awesome-icon :icon="['far', 'envelope-open-text']">
        </font-awesome-icon>
        Email
      </button>
      <button
        class="btn btn-sm btn-accent-1 btn-padding"
        aria-label="Rename wishlist"
        @click="onRenameClick">
        Rename
      </button>
    </div>
    <rename-wishlist-modal
      :show="showRenameModal"
      :wish-list-id="wishlist.id"
      :original-title="selectedTitle"
      @onClose="onRenameClose">
    </rename-wishlist-modal>
  </div>
</template>

<script>
import { format } from "date-fns";
import MoveToBasket from "~/Components/Wishlist/MoveToBasket.vue";
import RenameWishlistModal from "~/Components/Wishlist/RenameWishlistModal.vue";

export default {
  name: "WishlistCard",
  components: {
    MoveToBasket,
    RenameWishlistModal
  },
  props: {
    wishlist: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selectedTitle: null,
      showRenameModal: false
    };
  },
  methods: {
    formatDate ( input ) {
      return format( new Date( input ), "dd/MM/yyyy" );
    },
    onRenameClick () {
      this.selectedTitle = this.wishlist.title;
      this.showRenameModal = true;
    },
    onRenameClose ( newTitle ) {
      if ( newTitle ) {
        this.wishlist.title = newTitle;
      }
      this.showRenameModal = false;
    }
  }
};
</script>

<style lang="less" scoped>
.wishlist-card {
  position: relative;
  border: 2px solid #b2d6d9;
  background-color: #fff;
  padding: 10px;
  margin: 10px 0;

  &__delete {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;

    &:hover {
      color: #777;
      cursor: pointer;
    }
  }

  &__rename-button {
    font-size: 0.9rem;
    margin-left: 10px;
    color: #777;
  }

  &__save-button {
    margin-left: 10px;
  }

  &__name-input {
    max-width: 50%;
    display: inline;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 600;
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  &__date {
    font-size: 0.8rem;
    color: #666;
  }

  &__data {
    margin-top: 10px;
  }

  &__actions {
    border-top: 1px solid #b2d6d9;
    margin-top: 20px;
    padding-top: 5px;
    display: flex;
    flex-wrap: wrap;
  }

  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }

  .btn-padding {
    margin-right: 5px;
    margin-top: 5px;
  }
}
</style>
